import React from 'react'
import { EmpresaAPI, PedidoAPI, UsuarioAPI } from '../api'
import { EmpresasContext } from './EmpresasContext'
import { UsuarioContext } from './UsuarioContext'
import { LocalStorage } from '../services'
import RouterHook from './RouterHook'
import { Alerts } from '../components/Simple'
import credType from 'credit-card-type'
import CPF from 'cpf-validator'
import { FormatPhone } from '../utils'
import { AgendamentoContext } from './AgendamentoContext'
import StatusPagamentoAPI from '../api/StatusPagamentoAPI'
import moment from 'moment'

export const CheckoutContext = React.createContext({
  sttCtxChkt: {
    agendamentoConfirme: LocalStorage.get('agendamento-selecionado') || null,
    horaFixaSimulada: LocalStorage.get('agendamento-hora-fixa-simulada') || null,
    horaFixaSelecionada: LocalStorage.get('agendamento-hora-fixa') || null,
    esporteSelected: null,
    cpfObrigatorio: null,
    metodPay: null,
    dadosOk: true,
    cupomAplicado: null,
    selTotal: LocalStorage.get('agendamento-hora-fixa') ? true : false,
    selSinal: false,
    selPix: false,
    selCardCredit: false,
    selMaqCredit: false,
    selDinheiro: false,
    diaria: LocalStorage.get('diaria-selecionada') || null,
    isContaComprador: false,
    payment: null,
    pedidoPix: LocalStorage.get('pedido-pix') || null,
    diariaPix: LocalStorage.get('diaria-pix') || null,
    modePay: null,
    modePix: null,
    showP: false,
    cardSelected: null,
    modeVP: 'informar', // 'informar' || 'validar'
  },
  pagamentosDisponiveis: {
    pix: true | 'limiteDias',
    cartao: true | 'limiteDias',
    validacaoTelefone: false,
  },
  inpsChkt: {
    pais: '+55',
    phone: '',
    otpCode: '',
  },
  uiControlsChkt: {
    codeValido: false,
    otpCodeHelperText: '',
  },
  loadCh: {
    checkout: false,
    horaFx: false,
    page: false,
    cupom: false,
    pix: true,
    confirmar: false,
    confirmarDiaria: false,
    cartaoCredito: false,
    validarContaComprador: false,
    criarContaComprador: false,
    validPhone: false,
  },
  modaisChkt: {
    cpf: false,
    cupom: false,
    horaFx: false,
    cartaoCredito: false,
    selectEsporte: false,
    validPhone: false,
  },
  actionsChkt: {
    // eslint-disable-next-line no-unused-vars
    selectModePay: action => {},
    selectTotalPay: () => {},
    selectSinalPay: () => {},
    // eslint-disable-next-line no-unused-vars
    handleInpsChkt: (key, val) => {},
    // eslint-disable-next-line no-unused-vars
    handleModaisChkt: (key, val) => {},
    // eslint-disable-next-line no-unused-vars
    handleSttCtxChkt: (key, val) => {},
    // eslint-disable-next-line no-unused-vars
    handleSttCtxBuff: buff => {},
    clearHorarioFixo: () => {},
    // eslint-disable-next-line no-unused-vars
    ValidCpf: cpf => {},
    RemoverCupom: () => {},
    SelecionaHorarioFixo: () => {},
    // eslint-disable-next-line no-unused-vars
    SimulaHorarioFixo: async tipoMensalista => {},
    // eslint-disable-next-line no-unused-vars
    BuscarCartoesAtivos: async mode => {},
    ValidarContaComprador: async () => {},
    EnviarCodigoPhone: async () => {},
    ValidarCodigoPhone: async () => {},
    // eslint-disable-next-line no-unused-vars
    CriarContaComprador: async (cpf, telefone) => {},
    // eslint-disable-next-line no-unused-vars
    RemoveCreditCard: async idcard => {},
    ConfirmeAgendamentoFixo: async () => {},
    // eslint-disable-next-line no-unused-vars
    ConfirmeAgendamentoAvulso: async obs => {},
    // eslint-disable-next-line no-unused-vars
    VerificarCupom: async codigo => {},
    // eslint-disable-next-line no-unused-vars
    AdicionarCartao: async card => {},
    // eslint-disable-next-line no-unused-vars
    AgendarDiaria: async diaria => {},
    // eslint-disable-next-line no-unused-vars
    BuscarPrecoFixoId: async id => {},
  },
  actionsPix: {
    // eslint-disable-next-line no-unused-vars
    BuscarPagamentoPix: async idpagamento => {},
    // eslint-disable-next-line no-unused-vars
    handleModePix: val => {},
    // eslint-disable-next-line no-unused-vars
    handleShowP: val => {},
  },
})

export default function CheckoutContextProvider({ children }) {
  const serverRouter = RouterHook()
  const { userUCtx, actionsUCtx } = React.useContext(UsuarioContext)
  const { sttPg, actionsCtxEmps } = React.useContext(EmpresasContext)
  const { sttCtxAgend } = React.useContext(AgendamentoContext)

  const reagendamento = sttCtxAgend.reagendamento
  const [sttCtxChkt, setSttCtxChkt] = React.useState({
    agendamentoConfirme: LocalStorage.get('agendamento-selecionado') || null,
    horaFixaSimulada: LocalStorage.get('agendamento-hora-fixa-simulada') || null,
    horaFixaSelecionada: LocalStorage.get('agendamento-hora-fixa') || null,
    esporteSelected: null,
    cpfObrigatorio: null,
    metodPay: null,
    dadosOk: true,
    cupomAplicado: null,
    selTotal: LocalStorage.get('agendamento-hora-fixa') ? true : false,
    selSinal: false,
    selPix: Object.keys(reagendamento).length > 0 ? reagendamento.formaPagamento === 'PIX' : false,
    selCardCredit:
      Object.keys(reagendamento).length > 0
        ? reagendamento.formaPagamento === 'CARTAO_CREDITO'
        : false,
    selMaqCredit:
      Object.keys(reagendamento).length > 0
        ? reagendamento.formaPagamento === 'MAQUINA_CARTAO'
        : false,
    selDinheiro:
      Object.keys(reagendamento).length > 0 ? reagendamento.formaPagamento === 'DINHEIRO' : false,
    diaria: LocalStorage.get('diaria-selecionada') || null,
    isContaComprador: null, // 'valid' || 'invalid' || null = 'not_checked'
    pedidoPix: null,
    diariaPix: null,
    payment: null,
    modePay: 'PEDIDO',
    modePix: null,
    showP: false,
    cardSelected: null,
    modeVP: 'informar', // 'informar' || 'validar'
  })

  const [pagamentosDisponiveis, setPagamentosDisponiveis] = React.useState({
    pix: true,
    cartao: true,
    validacaoTelefone: false,
  })

  const [loadCh, setLoadCh] = React.useState({
    pix: true,
    page: false,
    horaFx: false,
    cupom: false,
    checkout: false,
    confirmar: false,
    confirmarDiaria: false,
    validarContaComprador: false,
    criarContaComprador: false,
    cartaoCredito: false,
    validPhone: false,
  })

  const [modaisChkt, setModaisChkt] = React.useState({
    cpf: false,
    cupom: false,
    horaFx: false,
    validPhone: false,
    cartaoCredito: false,
    selectEsporte: false,
  })

  const [inpsChkt, setInpsChkt] = React.useState({
    pais: '+55',
    phone: userUCtx.usuario?.atleta?.telefone ? userUCtx.usuario?.atleta?.telefone : '',
    otpCode: '',
  })

  const [uiControlsChkt, setUiControlsChkt] = React.useState({
    codeValido: false,
    otpCodeHelperText: '',
  })

  function ReturnMetodPay() {
    if (sttCtxChkt.selPix) {
      return 'PIX'
    } else if (sttCtxChkt.selCardCredit) {
      return 'CARTAO_CREDITO'
    } else if (sttCtxChkt.selMaqCredit) {
      return 'MAQUINA_CARTAO'
    } else if (sttCtxChkt.selDinheiro) {
      return 'DINHEIRO'
    }
  }

  React.useEffect(() => {
    if (sttPg.modePg !== 'checkout') {
      setSttCtxChkt(prevState => ({
        ...prevState,
        diaria: null,
        horaFixaSimulada: null,
        horaFixaSelecionada: null,
        agendamentoConfirme: null,
        selCardCredit: false,
        selDinheiro: false,
        selMaqCredit: false,
        selPix: false,
        selSinal: false,
        selTotal: false,
        cupomAplicado: null,
        cpfObrigatorio: null,
        esporteSelected: null,
        metodPay: null,
        showP: false,
      }))
      LocalStorage.remove('diaria-selecionada')
      LocalStorage.remove('agendamento-hora-fixa')
      LocalStorage.remove('agendamento-hora-fixa-simulada')
      LocalStorage.remove('agendamento-selecionado')
      setLoadCh(prevState => ({ ...prevState, checkout: false }))
    } else {
      const fetchPagamentosDisponiveis = async () => {
        const result = await getPagamentosDisponiveis()
        setPagamentosDisponiveis(result)
      }
      fetchPagamentosDisponiveis()
    }
  }, [sttPg.modePg])

  async function getPagamentosDisponiveis() {
    const res = await StatusPagamentoAPI.getStatusPagamento()
    const today = moment()
    const dataAgendamento = moment(sttCtxChkt.agendamentoConfirme?.agenda[0].dataInicio)
    const diasDiferenca = dataAgendamento.diff(today, 'days')
    if (diasDiferenca > 120) {
      res.pixAvaiable = 'limiteDias'
    }
    if (diasDiferenca > 28) {
      res.creditAvaiable = 'limiteDias'
    }
    if (!res || res.error) {
      return { pix: true, cartao: true, validacaoTelefone: false }
    }

    return {
      pix: res.pixAvaiable === undefined ? true : res.pixAvaiable,
      cartao: res.creditAvaiable === undefined ? true : res.creditAvaiable,
      validacaoTelefone:
        res.phoneValidationRequired === undefined ? false : res.phoneValidationRequired,
    }
  }

  function ReturnDiscount(tipo) {
    switch (tipo) {
      case 'Mensal':
        return sttPg.selectedQuadra.precoFixo?.descontoMensal || 0
      case 'Trimestral':
        return sttPg.selectedQuadra.precoFixo?.descontoTrimestral || 0
      case 'Semestral':
        return sttPg.selectedQuadra.precoFixo?.descontoSemestral || 0
      case 'Anual':
        return sttPg.selectedQuadra.precoFixo?.descontoAnual || 0
      case 'Indeterminado':
        return 0
      default:
        return 0
    }
  }

  function VerificaModePix(pay) {
    //console.log('Pay :: ', pay)
    if (pay.statusPagamento === 'PENDENTE') {
      return 'pendente'
    } else if (pay.statusPagamento === 'APROVADO') {
      return 'aprovado'
    } else if (pay.statusPagamento === 'CANCELADO') {
      return 'cancelado'
    } else if (pay.statusPagamento === 'NAO_APROVADO') {
      return 'nao_aprovado'
    } else {
      return 'error'
    }
  }

  function VerificaPhone() {
    if (pagamentosDisponiveis.validacaoTelefone === false) return true

    if (userUCtx.usuario.atleta.telefone && userUCtx.usuario.atleta.phoneValidated) {
      // console.log('Telefone validado')
      return true
    } else {
      return false
    }
  }

  function calcularValores(valorTotal, cupomDescount, selSinal, selTotal, porcentagemSinal) {
    let valorPendente = 0
    let valorAPagar = 0

    if (selSinal) {
      valorAPagar = (valorTotal - cupomDescount) * (porcentagemSinal / 100)
      valorPendente = valorTotal - cupomDescount - valorAPagar
    } else if (selTotal) {
      valorAPagar = valorTotal - cupomDescount
      valorPendente = valorTotal - cupomDescount
    }

    return { valorPendente, valorAPagar }
  }
  //console.log('sttCtxChkt :: ', sttCtxChkt)
  const actionsChkt = {
    SimulaHorarioFixo: async tipoMensalista => {
      const diaSemana = new Date(sttCtxChkt.agendamentoConfirme.dia + 'T06:00:00').getDay() + 1

      setLoadCh(prevState => ({ ...prevState, horaFx: true }))

      const ress = await EmpresaAPI.SimularMensalista(
        sttCtxChkt.agendamentoConfirme.quadra.idquadra,
        sttCtxChkt.agendamentoConfirme.agenda,
        tipoMensalista,
        diaSemana,
      )

      if (ress.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel calcular o valor do horário fixo, por favor tente novamente mais tarde',
        )
      } else {
        if (ress.retorno) {
          const descountPercentValue = ReturnDiscount(tipoMensalista)

          let valPer =
            sttCtxChkt.agendamentoConfirme.agenda[0].valor *
            sttCtxChkt.agendamentoConfirme.agenda.length
          valPer = valPer - sttCtxChkt.agendamentoConfirme.valorDesconto

          if (descountPercentValue > 0) {
            valPer = valPer - valPer * (descountPercentValue / 100)
          }

          let valCont = 0
          let valDesc = 0
          ress.registro.map(item => {
            if (item.idpedido) {
              item.status = 'OCUPADO'
              item.valor = valPer
            } else {
              valCont += valPer
              valDesc += sttCtxChkt.agendamentoConfirme.valorDesconto
              item.status = 'LIVRE'
              item.valor = valPer
            }
          })

          const hf_Data = {
            prePedidos: ress.registro,
            valorTotal: valCont,
            valorAPagar: valCont,
            ValorRealizado: 0,
            tipoMensalista: tipoMensalista,
            dataInicio: sttCtxChkt.agendamentoConfirme.agenda[0].dataInicio,
            dataFinal:
              sttCtxChkt.agendamentoConfirme.agenda[
                sttCtxChkt.agendamentoConfirme.agenda.length - 1
              ].dataFinal,
            descontoGeral: valDesc || 0,
          }
          LocalStorage.set('agendamento-hora-fixa-simulada', hf_Data)
          setSttCtxChkt(sttCtxChkt => ({ ...sttCtxChkt, horaFixaSimulada: hf_Data }))
        } else {
          Alerts.aviso('Aviso', 'Não foi possivel simular este horário fixo, ' + ress.mensagem)
        }
        setLoadCh(prevState => ({ ...prevState, horaFx: false }))
        return ress
      }
    },
    ConfirmeAgendamentoAvulso: async observations => {
      if (!sttPg.empresa.status || !sttPg.empresa.licenca.status)
        return Alerts.swal(
          'warning',
          'Aviso',
          'Este centro esportivo não está aceitando agendamentos no momento, tente novamente mais tarde',
        )
      setLoadCh(prevState => ({ ...prevState, confirmar: true }))
      let valorTotal = sttCtxChkt.agendamentoConfirme.valorTotal
      // valor total ja esta vindo com o descontValue aplicado
      // const descountValue = sttCtxChkt.agendamentoConfirme.valorDesconto || 0
      const cupomDescount = sttCtxChkt.cupomAplicado?.valorDesconto || 0
      const porcentagem_sinal =
        sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.porcentagemSinal
      const { valorPendente, valorAPagar } = calcularValores(
        valorTotal,
        cupomDescount,
        sttCtxChkt.selSinal,
        sttCtxChkt.selTotal,
        porcentagem_sinal,
      )

      const buffer = {
        usuario_idusuario: userUCtx.usuario.idusuario,
        dataInicio: sttCtxChkt.agendamentoConfirme.agenda[0].dataInicio,
        dataFinal:
          sttCtxChkt.agendamentoConfirme.agenda[sttCtxChkt.agendamentoConfirme.agenda.length - 1]
            .dataFinal,
        quadra_idquadra: sttCtxChkt.agendamentoConfirme.quadra.idquadra,
        formaPagamento: ReturnMetodPay(),
        observacoes: observations,
        fromSite: true,
        regraCancelamento_idregraCancelamento:
          sttPg.empresa.regrasCancelamento[0]?.idregraCancelamento || null,
        regraAgendamento_idregraAgendamento:
          sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.idregraAgendamento,
        cupomDesconto_idcupomDesconto: sttCtxChkt.cupomAplicado
          ? sttCtxChkt.cupomAplicado.idcupomDesconto
          : null,
        usuario_cpf: sttCtxChkt.cpfObrigatorio,
        cardToken:
          ReturnMetodPay() === 'CARTAO_CREDITO' ? sttCtxChkt.cardSelected.card_token : null,
        cardMethod:
          ReturnMetodPay() === 'CARTAO_CREDITO' ? sttCtxChkt.cardSelected.payment_method_id : null,
        valorPendente: valorPendente,
        valorAPagar: valorAPagar,
        valorDesconto: sttCtxChkt.cupomAplicado?.valorDesconto || 0,
        categoriaEsporte_idcategoriaEsporte: sttCtxChkt.esporteSelected
          ? sttCtxChkt.esporteSelected.idcategoriaEsporte
          : null,
        valorTotal: valorTotal,
      }
      const req = await EmpresaAPI.SolicitarPedidoNovaGrade(buffer)
      // console.log('Req :: ', req)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel solicitar o agendamento, por favor, verifique sua conexão com a internet e tente novamente',
        )
        setLoadCh(prevState => ({ ...prevState, confirmar: false }))
        return false
      }

      if (req.retorno) {
        Alerts.swal('success', 'Sucesso', 'Agendamento solicitado com sucesso')

        setSttCtxChkt(prevState => ({
          ...prevState,
          horaFixaSimulada: null,
          horaFixaSelecionada: null,
          agendamentoConfirme: null,
          pedidoPix: sttCtxChkt.selPix ? req.registro : null,
        }))
        actionsCtxEmps.handleModeSttPg({
          modePg: 'quadras',
          selectedHorarios: [],
          selectedQuadra: null,
        })

        LocalStorage.remove('selected-quadra')
        LocalStorage.remove('agendamento-hora-fixa')
        LocalStorage.remove('agendamento-hora-fixa-simulada')
        LocalStorage.remove('agendamento-selecionado')

        if (sttCtxChkt.selPix) {
          LocalStorage.set('pedido-pix', req.registro)
          serverRouter('pay-pix', req.registro.idpagamento)
        } else {
          serverRouter('agendamento', req.registro.idpedido)
        }
      }
      setLoadCh(prevState => ({ ...prevState, confirmar: false }))
      setSttCtxChkt(prevState => ({
        ...prevState,
        cupomAplicado: null,
        cpfObrigatorio: null,
        esporteSelected: null,
        metodPay: null,
        selSinal: false,
        selTotal: false,
        selPix: false,
        selCardCredit: false,
        selMaqCredit: false,
        selDinheiro: false,
      }))
    },
    ReagendarPedido: async (idpedido, observations) => {
      const pagamentoLocal =
        Object.keys(reagendamento).length > 0
          ? reagendamento.formaPagamento === 'MAQUINA_CARTAO' ||
            reagendamento.formaPagamento === 'LOCAL' ||
            reagendamento.formaPagamento === 'DINHEIRO'
          : ReturnMetodPay() === 'MAQUINA_CARTAO' ||
            ReturnMetodPay() === 'LOCAL' ||
            ReturnMetodPay() === 'DINHEIRO'

      let valorTotal = sttCtxChkt.agendamentoConfirme.valorTotal
      // valor total ja esta vindo com o descontValue aplicado
      // const descountValue = sttCtxChkt.agendamentoConfirme.valorDesconto || 0
      const cupomDescount = reagendamento.valorDesconto || 0
      const porcentagem_sinal =
        sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.porcentagemSinal
      const { valorPendente, valorAPagar } = calcularValores(
        valorTotal,
        cupomDescount,
        sttCtxChkt.selSinal,
        sttCtxChkt.selTotal,
        porcentagem_sinal,
      )
      const buffer = {
        pedido: {
          idpedido: idpedido,
          dataInicio: sttCtxChkt.agendamentoConfirme.agenda[0].dataInicio,
          dataFinal:
            sttCtxChkt.agendamentoConfirme.agenda[sttCtxChkt.agendamentoConfirme.agenda.length - 1]
              .dataFinal,
          quadra_idquadra: sttCtxChkt.agendamentoConfirme.quadra.idquadra,
          formaPagamento: ReturnMetodPay(),
          observacoes: observations,
          fromSite: reagendamento.fromSite,
          regraCancelamento_idregraCancelamento:
            sttPg.empresa.regrasCancelamento[0]?.idregraCancelamento || null,
          valorAPagar: pagamentoLocal ? valorAPagar : reagendamento.valorAPagar,
          valorPendente: pagamentoLocal ? valorPendente : reagendamento.valorPendente,
          valorDesconto: reagendamento.valorDesconto,
          categoriaEsporte_idcategoriaEsporte: sttCtxChkt.esporteSelected.idcategoriaEsporte,
          valorTotal: pagamentoLocal
            ? sttCtxChkt.agendamentoConfirme.valorTotal -
              sttCtxChkt.agendamentoConfirme.valorDesconto
            : reagendamento.valorTotal,
          criadoPor: userUCtx.usuario.nome,
        },
        reagendadoPor: userUCtx.usuario.idusuario,
      }
      const req = await EmpresaAPI.SolicitarReagendamento(buffer)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel solicitar o reagendamento, por favor, verifique sua conexão com a internet e tente novamente',
        )
        return false
      }
      if (req.retorno) {
        Alerts.swal(
          'success',
          'Sucesso',
          'Reagendamento solicitado com sucesso',
          () => (
            serverRouter('agendamento', idpedido),
            actionsCtxEmps.handleModeSttPg({
              modePg: 'quadras',
              selectedHorarios: [],
              selectedQuadra: null,
            })
          ),
        )
      }
    },
    ConfirmeAgendamentoFixo: async observations => {
      if (!sttPg.empresa.status || !sttPg.empresa.licenca.status)
        return Alerts.swal(
          'warning',
          'Aviso',
          'Este centro esportivo não está aceitando agendamentos no momento, tente novamente mais tarde',
        )
      const blocoMensalista = {
        valorPorPedido: sttCtxChkt.horaFixaSelecionada.prePedidos[0].valor,
        usuario_idusuario: userUCtx.usuario.idusuario,
        quadra_idquadra: sttCtxChkt.agendamentoConfirme.quadra.idquadra,
        empresa_idempresa: sttPg.empresa.idempresa,
        tipoMensalista: sttCtxChkt.horaFixaSelecionada.tipoMensalista,
        diaSemana:
          new Date(
            sttCtxChkt.agendamentoConfirme.dia.includes('T')
              ? sttCtxChkt.agendamentoConfirme.dia
              : sttCtxChkt.agendamentoConfirme.dia + 'T06:00:00',
          ).getDay() + 1,
        formaPagamento: ReturnMetodPay(),
        regraAgendamentoPedidos:
          sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.idregraAgendamento,
        regraCancelamentoPedidos: sttPg.empresa.regrasCancelamento[0].idregraCancelamento,
        cupomdesconto_idcupomDesconto: sttCtxChkt.cupomAplicado
          ? sttCtxChkt.cupomAplicado.idcupomDesconto
          : null,
        valorDescontoCupom: sttCtxChkt.cupomAplicado ? sttCtxChkt.cupomAplicado.valorDesconto : 0,
        observacao: observations,
        pedidos: sttCtxChkt.horaFixaSelecionada.prePedidos.filter(item => item.status === 'LIVRE'),
        usuario_cpf: sttCtxChkt.cpfObrigatorio,
        categoriaEsporte_idcategoriaEsporte: sttCtxChkt.esporteSelected
          ? sttCtxChkt.esporteSelected.idcategoriaEsporte
          : null,
      }

      setLoadCh(prevState => ({ ...prevState, confirmar: true }))
      const reqs = await EmpresaAPI.CriarMensalista(blocoMensalista)

      if (reqs.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel solicitar o agendamento, por favor, verifique sua conexão com a internet e tente novamente',
        )
        setLoadCh(prevState => ({ ...prevState, confirmar: false }))
        return false
      }

      if (reqs.retorno) {
        Alerts.swal(
          'success',
          'Sucesso',
          'Seu agendamento foi solicitado com sucesso, aguarde a confirmação da quadra para que o agendamento seja confirmado',
        )

        setSttCtxChkt(prevState => ({
          ...prevState,
          horaFixaSimulada: null,
          horaFixaSelecionada: null,
          agendamentoConfirme: null,
          selCardCredit: false,
          selDinheiro: false,
          selMaqCredit: false,
          selPix: false,
          selSinal: false,
          selTotal: false,
          cupomAplicado: null,
          cpfObrigatorio: null,
          esporteSelected: null,
          metodPay: null,
        }))

        actionsCtxEmps.clearSelectedHorarios()

        LocalStorage.remove('agendamento-hora-fixa')
        LocalStorage.remove('agendamento-hora-fixa-simulada')
        LocalStorage.remove('agendamento-selecionado')

        serverRouter('mensalista', reqs.registro.mensalista.idmensalista)

        setLoadCh(prevState => ({ ...prevState, confirmar: false }))
      }
    },
    AgendarDiaria: async () => {
      //console.log('AgendarDiaria :: ', sttPg)
      //console.log('AgendarDiaria :: ', sttCtxChkt)

      // Exemplo app
      // {
      //   "criadoPorGestor": 0,
      //   "criadorPor": "Suporte Agendei Quadras",
      //   "data": "2024-11-10T12:00:00+00:00",
      //   "dayuse_iddayuse": 277,
      //   "empresa_idempresa": 9,
      //   "usuario_idusuario": 303,
      //   "formaPagamento": "PIX",
      //   "valorRealizado": 10,
      //   "valorTotal": 10
      //   "transacao": {"tipo": "PIX"},
      // }

      const data = {
        fromSite: 1,
        criadoPorGestor: 0,
        criadoPor: userUCtx.usuario.nome,
        // retornar data nesse formato T12:00:00+00:00
        data: sttPg.selectedDay.format('YYYY-MM-DD') + 'T12:00:00+00:00',
        dayuse_iddayuse: sttCtxChkt.diaria.iddayuse,
        empresa_idempresa: sttPg.empresa.idempresa,
        usuario_idusuario: userUCtx.usuario.idusuario,
        formaPagamento: sttCtxChkt.selPix
          ? 'PIX'
          : sttCtxChkt.selCardCredit
            ? 'CARTAO_CREDITO'
            : 'LOCAL',
        valorRealizado: sttCtxChkt.diaria.valor,
        valorTotal: sttCtxChkt.diaria.valor,
        transacao: sttCtxChkt.selCardCredit
          ? {
              tipo: 'CARTAO_CREDITO',
              payment_method_id: sttCtxChkt.diaria.cartaoSelecionado.payment_method_id,
              card_token: sttCtxChkt.diaria.cartaoSelecionado.card_token,
            }
          : sttCtxChkt.selPix
            ? { tipo: 'PIX' }
            : // pagamento local
              { tipo: 'LOCAL' },
      }

      //console.log('Data :: ', data)
      setLoadCh(prevState => ({ ...prevState, confirmarDiaria: true }))
      const req = await EmpresaAPI.SolicitarDiaria(data)

      //console.log('Req :: ', req)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel solicitar a diária, por favor, tente novamente mais tarde',
        )
        setLoadCh(prevState => ({ ...prevState, confirmarDiaria: false }))
        return false
      }

      if (req.idcompraDayuse) {
        //console.log('req :: ', req)
        Alerts.swal('success', 'Sucesso', 'Diária solicitada com sucesso')
        if (sttCtxChkt.selPix) {
          LocalStorage.set('diaria-pix', req.pagamento)
          setSttCtxChkt(prevState => ({ ...prevState, diariaPix: req, modePay: 'DIARIA' }))
          serverRouter('pay-pix', req.pagamento.idExternoPagamento)
        } else {
          serverRouter('diaria', req.idcompraDayuse)
        }
      }
      setLoadCh(prevState => ({ ...prevState, confirmarDiaria: false }))
    },
    VerificarCupom: async codigo => {
      const cupomBuffer = {
        codigo: codigo,
        tipoPagamento: sttCtxChkt.selPix || sttCtxChkt.selCardCredit ? 'ONLINE' : 'LOCAL',
        tipoPedido: sttCtxChkt.horaFixaSelecionada ? 'MENSALISTA' : 'AVULSO',
        pedido: {
          valorTotal: sttCtxChkt.agendamentoConfirme.valorTotal,
          empresa_idempresa: sttPg.empresa.idempresa,
          usuario_idusuario: userUCtx.usuario.idusuario,
        },
      }

      setLoadCh(prevState => ({ ...prevState, cupom: true }))
      const req = await PedidoAPI.VerificarCupom(cupomBuffer)

      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel verificar o cupom, por favor tente novamente mais tarde',
        )
        setLoadCh(prevState => ({ ...prevState, cupom: false }))
        return false
      }
      if (req.retorno) {
        if (sttCtxChkt.horaFixaSelecionada === null && req.cupom.aplicarAvulso) {
          Alerts.swal('success', 'Sucesso', 'Cupom aplicado com sucesso')
          setSttCtxChkt(prevState => ({ ...prevState, cupomAplicado: req.cupom }))
          setLoadCh(prevState => ({ ...prevState, cupom: false }))
          return true
        }
        if (sttCtxChkt.horaFixaSelecionada !== null && req.cupom.aplicarMensalista) {
          const descountValue =
            req.cupom.valorDesconto /
            sttCtxChkt.horaFixaSelecionada.prePedidos.filter(item => item.status === 'LIVRE').length
          const prePdd = sttCtxChkt.horaFixaSelecionada.prePedidos.map(item => {
            if (item.status === 'LIVRE') {
              item.valor = item.valor - descountValue
            }
            return item
          })
          setSttCtxChkt(prevState => ({
            ...prevState,
            cupomAplicado: req.cupom,
            horaFixaSelecionada: { ...sttCtxChkt.horaFixaSelecionada, prePedidos: prePdd },
          }))

          Alerts.swal('success', 'Sucesso', 'Cupom aplicado com sucesso')
          setLoadCh(prevState => ({ ...prevState, cupom: false }))
          return true
        }
        Alerts.swal(
          'warning',
          'Aviso',
          'Parece que tivemos um problema e o cupom não pode ser aplicado, por favor, verifique o código do cupom e tente novamente.',
        )
        setLoadCh(prevState => ({ ...prevState, cupom: false }))
        return false
      } else {
        Alerts.swal('warning', 'Aviso', req.mensagem)
        setLoadCh(prevState => ({ ...prevState, cupom: false }))
        return false
      }
    },
    EnviarCodigoPhone: async () => {
      setLoadCh(prev => ({ ...prev, validPhone: true }))
      const data = {
        usuario_idusuario: userUCtx.usuario.idusuario,
        ddi: inpsChkt.pais,
        phone: FormatPhone(inpsChkt.phone),
      }
      const req = await UsuarioAPI.ValidarTelefone(data)
      // console.log('req :: ', req)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel enviar o código de validação, por favor tente novamente mais tarde',
        )
        setLoadCh(prev => ({ ...prev, validPhone: false }))
        return false
      }
      if (req.detalhes?.phone && req.detalhes?.expiresAt) {
        Alerts.swal(
          'success',
          'Sucesso',
          'Código de validação enviado com sucesso, informe o código recebido',
        )
        setSttCtxChkt(prev => ({ ...prev, modeVP: 'validar' }))
        setInpsChkt(prev => ({ ...prev, otpCode: '' }))
        setUiControlsChkt(prev => ({ ...prev, codeValido: false, otpCodeHelperText: '' }))
        LocalStorage.set('validPhoneData', req)
        setLoadCh(prev => ({ ...prev, validPhone: false }))
        return true
      } else {
        Alerts.swal('warning', 'Aviso', req.mensagem)
        setLoadCh(prev => ({ ...prev, validPhone: false }))
        return false
      }
    },
    ValidarCodigoPhone: async () => {
      setLoadCh(prev => ({ ...prev, validPhone: true }))
      const data = {
        usuario_idusuario: userUCtx.usuario.idusuario,
        phone: FormatPhone(inpsChkt.phone),
        code: inpsChkt.otpCode,
        ddi: inpsChkt.pais,
      }
      const req = await UsuarioAPI.ValidarCodigoTelefone(data)
      // console.log('req :: ', req)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel validar o código de validação, por favor tente novamente mais tarde',
        )
        setLoadCh(prev => ({ ...prev, validPhone: false }))
        return false
      }
      if (req.retorno) {
        Alerts.swal('success', 'Sucesso', 'Telefone validado com sucesso')
        const user = {
          ...userUCtx.usuario,
          atleta: { ...userUCtx.usuario.atleta, phoneValidated: true },
        }
        await actionsUCtx.AtualizarUsuario(user)
        const selected = LocalStorage.get('validPhoneSel')
        if (selected === 'pix') {
          setSttCtxChkt(prevState => ({
            ...prevState,
            cupomAplicado: null,
            selPix: !prevState.selPix,
            selCardCredit: false,
            selMaqCredit: false,
            selDinheiro: false,
            horaFixaSelecionada: prevState.horaFixaSelecionada,
            horaFixaSimulada: prevState.horaFixaSelecionada,
            modeVP: 'informar',
          }))
          setModaisChkt(prev => ({ ...prev, validPhone: false }))
        } else {
          const cardCred = LocalStorage.get('cardSelectedValidPhone')
          if (!cardCred) return console.error('Erro ao buscar cartão de crédito')
          setSttCtxChkt(prevState => ({
            ...prevState,
            cupomAplicado: null,
            selPix: false,
            selCardCredit: cardCred ? true : false,
            selMaqCredit: false,
            selDinheiro: false,
            horaFixaSelecionada: prevState.horaFixaSelecionada,
            horaFixaSimulada: prevState.horaFixaSelecionada,
            cardSelected: cardCred || null,
          }))
          setModaisChkt(prevState => ({ ...prevState, cartaoCredito: false }))
        }
        setLoadCh(prev => ({ ...prev, validPhone: false }))
        return true
      } else {
        Alerts.swal('warning', 'Aviso', req.mensage)
        setLoadCh(prev => ({ ...prev, validPhone: false }))
        return false
      }
    },
    BuscarCartoesAtivos: async () => {
      setLoadCh(prevState => ({ ...prevState, cartaoCredito: true }))
      const req = await UsuarioAPI.BuscarCartoesAtivos(userUCtx.usuario.idusuario)
      //console.log('req :: ', req)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel carregar seus cartões, por favor tente novamente mais tarde',
        )
      }
      if (req.length) {
        setLoadCh(prevState => ({ ...prevState, cartaoCredito: false }))
        return req
      } else {
        setLoadCh(prevState => ({ ...prevState, cartaoCredito: false }))
        return []
      }
    },
    AdicionarCartao: async card => {
      /*
      AddCreditCard : async (token, nome, bandeira, numCard, validade, cvc, id) => { 

        const array_validade = validade.split("/");
        
        if(array_validade[1].length == 2) array_validade[1] = "20" + array_validade[1];

        const card = {
          payment_method_name   : bandeira[0].type,
          card_name             : nome.toUpperCase(),
          card_number           : numCard,
          card_expdate_month    : array_validade[0],
          card_expdate_year     : array_validade[1],
          card_cvv              : cvc,
          idExternoCliente      : id, 
          idEstabelecimento     : 4   
        }
        
        const ress = await api.Usuarios.add_credit_card(token, card);
        
        if(ress.status) return {status : true, req : ress.req};
        else return {status : false, req : ress.req};
      },*/
      const { nome, numCard, validade, cvc } = card
      if (nome.length && numCard.length && validade.length === 5 && cvc.length === 3) {
        const bandeira = credType(numCard)
        const array_validade = validade.split('/')
        if (array_validade[1].length == 2) array_validade[1] = '20' + array_validade[1]
        const card = {
          payment_method_name: bandeira[0].type,
          card_name: nome.toUpperCase(),
          card_number: numCard,
          card_expdate_month: array_validade[0],
          card_expdate_year: array_validade[1],
          card_cvv: cvc,
          idExternoCliente: userUCtx.usuario.idusuario,
          idEstabelecimento: 4,
        }
        setLoadCh(prevState => ({ ...prevState, cartaoCredito: true }))
        const req = await UsuarioAPI.AdicionarCartao(card)
        if (req.error) {
          Alerts.swal(
            'warning',
            'Aviso',
            'Não foi possivel adicionar o cartão de crédito, por favor tente novamente mais tarde',
          )
        }
        if (req.retorno) {
          Alerts.swal('success', 'Sucesso', 'Cartão de crédito adicionado com sucesso')
          await actionsChkt.BuscarCartoesAtivos(true)
          setLoadCh(prevState => ({ ...prevState, cartaoCredito: false }))
          return true
        } else {
          Alerts.swal('warning', 'Aviso', req.mensagem)
        }
        setLoadCh(prevState => ({ ...prevState, cartaoCredito: false }))
        return false
      }
    },
    ValidarContaComprador: async () => {
      setLoadCh(prevState => ({ ...prevState, validarContaComprador: true }))
      const req = await UsuarioAPI.ValidarContaComprador(userUCtx.usuario.idusuario)
      //console.log('req :: ', req)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel validar a conta do comprador, por favor tente novamente mais tarde',
        )
      }
      if (req.retorno) {
        //console.log('req :: ', req)
        setSttCtxChkt(prevState => ({ ...prevState, isContaComprador: 'valid' }))
      } else {
        setSttCtxChkt(prevState => ({ ...prevState, isContaComprador: 'invalid' }))
      }
      setLoadCh(prevState => ({ ...prevState, validarContaComprador: false }))
    },
    CriarContaComprador: async (cpf, telefone) => {
      // Validar cpf e telefone com validator
      if (CPF.isValid(cpf) && telefone.length > 11) {
        const buffer = {
          idusuario: userUCtx.usuario.idusuario,
          cpf,
          telefone,
        }
        setLoadCh(prevState => ({ ...prevState, criarContaComprador: true }))
        const req = await UsuarioAPI.CriarContaComprador(buffer)
        //console.log('req :: ', req)
        if (req.error) {
          Alerts.swal(
            'warning',
            'Aviso',
            'Não foi possivel validar a conta do comprador, por favor tente novamente mais tarde',
          )
        }
        if (req.usuario && req.usuarioAPIPagamento) {
          setSttCtxChkt(prevState => ({ ...prevState, isContaComprador: 'valid' }))
        } else {
          Alerts.swal(
            'warning',
            'Aviso',
            'Não foi possível criar sua conta para utilizar o cartão de crédit. Por favor, valide suas credenciais e tente novamente mais tarde',
          )
          setSttCtxChkt(prevState => ({ ...prevState, isContaComprador: 'invalid' }))
        }
        setLoadCh(prevState => ({ ...prevState, criarContaComprador: false }))
      }
    },
    RemoveCreditCard: async idcard => {
      setLoadCh(prevState => ({ ...prevState, cartaoCredito: true }))
      const req = await UsuarioAPI.RemoverCartaoCredito(idcard)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel remover o cartão de crédito, por favor tente novamente mais tarde',
        )
      }
      if (req.retorno) {
        Alerts.swal('success', 'Sucesso', 'Cartão de crédito removido com sucesso')
        await actionsChkt.BuscarCartoesAtivos(true)
        setLoadCh(prevState => ({ ...prevState, cartaoCredito: false }))
        return true
      } else {
        Alerts.swal('warning', 'Aviso', req.mensagem)
      }
      setLoadCh(prevState => ({ ...prevState, cartaoCredito: false }))
    },
    ValidCpf: cpfVal => {
      if (cpfVal === null) {
        setSttCtxChkt(prevState => ({ ...prevState, cpfObrigatorio: null }))
        setModaisChkt(prevState => ({ ...prevState, cpf: false }))
      } else if (CPF.isValid(cpfVal)) {
        setSttCtxChkt(prevState => ({ ...prevState, cpfObrigatorio: cpfVal }))
        setModaisChkt(prevState => ({ ...prevState, cpf: false }))
      } else {
        Alerts.swal(
          'warning',
          'Aviso',
          'CPF inválido, por favor, verifique o CPF e tente novamente',
        )
      }
    },
    RemoverCupom: () => {
      if (sttCtxChkt.horaFixaSelecionada !== null) {
        setSttCtxChkt(prevState => ({
          ...prevState,
          cupomAplicado: null,
          horaFixaSelecionada: sttCtxChkt.horaFixaSimulada,
        }))
      } else {
        setSttCtxChkt(prevState => ({ ...prevState, cupomAplicado: null }))
      }
    },
    SelecionaHorarioFixo: () => {
      LocalStorage.set('agendamento-hora-fixa', sttCtxChkt.horaFixaSimulada)
      setSttCtxChkt(prevState => ({
        ...prevState,
        cupomAplicado: null,
        horaFixaSelecionada: sttCtxChkt.horaFixaSimulada,
        selTotal: true,
        selSinal: false,
        selCardCredit: false,
        selDinheiro: false,
        selMaqCredit: false,
        selPix: false,
      }))
    },
    BuscarPrecoFixoId: async () => {
      setLoadCh(prevState => ({ ...prevState, horaFx: true }))
      const req = await EmpresaAPI.BuscarPrecoFixoId(sttPg.selectedQuadra.precoFixo_idprecoFixo)

      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel carregar o preço fixo, por favor tente novamente mais tarde',
        )
        actionsChkt.handleModaisChkt('horaFx', false)
      }

      if (req.idprecoFixo) {
        actionsCtxEmps.handleQuadraSelected({ ...sttPg.selectedQuadra, precoFixo: req })
      }

      setLoadCh(prevState => ({ ...prevState, horaFx: false }))
    },
    clearHorarioFixo: () => {
      LocalStorage.remove('agendamento-hora-fixa')
      LocalStorage.remove('agendamento-hora-fixa-simulada')
      setSttCtxChkt(prevState => ({
        ...prevState,
        horaFixaSimulada: null,
        horaFixaSelecionada: null,
      }))
    },
    selectTotalPay: () => {
      function RunRotine() {
        if (sttCtxChkt.selTotal) {
          setSttCtxChkt(prevState => ({
            ...prevState,
            cupomAplicado: null,
            selTotal: false,
            selPix: false,
            selCardCredit: false,
            selMaqCredit: false,
            selDinheiro: false,
          }))
        } else {
          setSttCtxChkt(prevState => ({
            ...prevState,
            cupomAplicado: null,
            selTotal: true,
            selSinal: false,

            selPix: false,
            selCardCredit: false,
            selMaqCredit: false,
            selDinheiro: false,
          }))
        }
      }
      if (sttCtxChkt.cupomAplicado !== null) {
        Alerts.question(
          'Aviso',
          'Se você mudar o modo de pagamento, o cupom será removido, deseja continuar?',
          RunRotine,
        )
      } else {
        RunRotine()
      }
    },
    selectSinalPay: () => {
      function RunRotine() {
        if (sttCtxChkt.selSinal) {
          setSttCtxChkt(prevState => ({
            ...prevState,
            cupomAplicado: null,
            selTotal: false,
            selSinal: false,
            selPix: false,
            selCardCredit: false,
            selMaqCredit: false,
            selDinheiro: false,
          }))
        } else {
          setSttCtxChkt(prevState => ({
            ...prevState,
            cupomAplicado: null,
            selSinal: true,
            selTotal: false,

            selPix: false,
            selCardCredit: false,
            selMaqCredit: false,
            selDinheiro: false,
          }))
        }
      }
      if (sttCtxChkt.cupomAplicado !== null) {
        Alerts.question(
          'Aviso',
          'Se você mudar o modo de pagamento, o cupom será removido, deseja continuar?',
          RunRotine,
        )
      } else {
        RunRotine()
      }
    },
    selectModePay: (action, cardCred = null) => {
      function CorrigeHF() {
        let newValue = 0
        sttCtxChkt.horaFixaSelecionada.prePedidos.map(item => {
          if (item.status === 'LIVRE') {
            item.valor = item.valor + sttCtxChkt.cupomAplicado.valorDesconto
            newValue += item.valor
          }
        })
        sttCtxChkt.horaFixaSelecionada.valorAPagar = newValue
        sttCtxChkt.horaFixaSelecionada.valorTotal = newValue
      }
      function RunRotine() {
        if (sttCtxChkt.cupomAplicado !== null && sttCtxChkt.horaFixaSelecionada !== null) {
          CorrigeHF()
        }
        switch (action) {
          case 'pix':
            if (VerificaPhone()) {
              setSttCtxChkt(prevState => ({
                ...prevState,
                cupomAplicado: null,
                selPix: !prevState.selPix,
                selCardCredit: false,
                selMaqCredit: false,
                selDinheiro: false,
                horaFixaSelecionada: prevState.horaFixaSelecionada,
                horaFixaSimulada: prevState.horaFixaSelecionada,
              }))
            } else {
              setModaisChkt(prevState => ({ ...prevState, validPhone: true }))
              setInpsChkt(prevState => ({
                ...prevState,
                phone: userUCtx.usuario.atleta.telefone || '',
              }))
              LocalStorage.set('validPhoneSel', 'pix')
            }
            break
          case 'card':
            if (VerificaPhone()) {
              setSttCtxChkt(prevState => ({
                ...prevState,
                cupomAplicado: null,
                selPix: false,
                selCardCredit: cardCred ? true : false,
                selMaqCredit: false,
                selDinheiro: false,
                horaFixaSelecionada: prevState.horaFixaSelecionada,
                horaFixaSimulada: prevState.horaFixaSelecionada,
                cardSelected: cardCred,
              }))
              setModaisChkt(prevState => ({ ...prevState, cartaoCredito: false }))
            } else {
              setModaisChkt(prevState => ({ ...prevState, validPhone: true, cartaoCredito: false }))
              setInpsChkt(prevState => ({
                ...prevState,
                phone: userUCtx.usuario.atleta.telefone || '',
              }))
              LocalStorage.set('validPhoneSel', 'card')
              LocalStorage.set('cardSelectedValidPhone', cardCred)
            }
            break
          case 'maq':
            setSttCtxChkt(prevState => ({
              ...prevState,
              cupomAplicado: null,
              selPix: false,
              selCardCredit: false,
              selMaqCredit: !prevState.selMaqCredit,
              selDinheiro: false,
              horaFixaSelecionada: prevState.horaFixaSelecionada,
              horaFixaSimulada: prevState.horaFixaSelecionada,
            }))
            break
          case 'dinheiro':
            setSttCtxChkt(prevState => ({
              ...prevState,
              cupomAplicado: null,
              selPix: false,
              selCardCredit: false,
              selMaqCredit: false,
              selDinheiro: !prevState.selDinheiro,
              horaFixaSelecionada: prevState.horaFixaSelecionada,
              horaFixaSimulada: prevState.horaFixaSelecionada,
            }))
            break
          default:
            break
        }
      }
      if (sttCtxChkt.cupomAplicado !== null) {
        Alerts.question(
          'Aviso',
          'Se você mudar o modo de pagamento, o cupom será removido, deseja continuar?',
          RunRotine,
        )
      } else {
        RunRotine()
      }
    },
    handleInpsChkt: (key, val) => {
      if (key === 'phone') {
        if (inpsChkt.pais === '+55')
          setInpsChkt(prevState => ({ ...prevState, [key]: FormatPhone(val, inpsChkt.pais) }))
        else {
          if (val.length > 15) return
          setInpsChkt(prevState => ({ ...prevState, [key]: val.replace(/\D/g, '') }))
        }
      } else if (key === 'pais') {
        setInpsChkt(prevState => ({ ...prevState, [key]: val, phone: '' }))
      } else {
        setInpsChkt(prevState => ({ ...prevState, [key]: val }))
      }
    },
    handleModaisChkt: (key, val) => {
      setModaisChkt(prev => ({ ...prev, [key]: val }))
    },
    handleSttCtxChkt: (key, val) => {
      setSttCtxChkt(prevState => {
        return { ...prevState, [key]: val }
      })
    },
    handleSttCtxBuff: buff => {
      // console.log('buff :: ', buff)
      setSttCtxChkt(prevState => ({ ...prevState, ...buff }))
    },
  }
  //console.log('sttCtxChkt :: ', sttCtxChkt)
  const actionsPix = {
    BuscarPagamentoPix: async (idpagamento, mode = true) => {
      setLoadCh(prevState => ({ ...prevState, pix: true }))
      //console.log('idpagamento :: ', idpagamento, mode)
      const req = await PedidoAPI.BuscarPagamentoId(idpagamento)
      //console.log('req :: ', req)
      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Não foi possivel carregar o pagamento, por favor tente novamente mais tarde',
        )
      }
      //console.log('req :: ', req, idpagamento)
      if (req.idpagamento === parseInt(idpagamento)) {
        const modePix = VerificaModePix(req)
        //console.log('ModePix :: ', modePix)
        setSttCtxChkt(prevState => ({
          ...prevState,
          payment: req,
          modePix: modePix,
          modePay: mode ? 'PEDIDO' : 'DIARIA',
        }))
      }
      setLoadCh(prevState => ({ ...prevState, pix: false }))
    },
    handleModePix: val => {
      setSttCtxChkt(prevState => ({ ...prevState, modePix: val }))
    },
    handleShowP: val => {
      setSttCtxChkt(prevState => ({ ...prevState, showP: val }))
    },
  }

  return (
    <CheckoutContext.Provider
      value={{
        sttCtxChkt,
        pagamentosDisponiveis,
        loadCh,
        modaisChkt,
        actionsChkt,
        actionsPix,
        inpsChkt,
        uiControlsChkt,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  )
}
